module.exports = __webpack_public_path__ + "static/media/PeakPerformanceBuoyancy.d84cc8cb.jpg";